import React from 'react';
import {
    Grid,
    TextField,
    Typography,
    Autocomplete,
    createFilterOptions,
    FormControl,
    Checkbox,
    Chip,
    FormHelperText
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { orderBy } from 'lodash';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const filterOptions = createFilterOptions<any>({
    stringify: option => option.name
});

interface BasicDetailsStepProps {
    contractName: string;
    values: any;
    touched: any;
    errors: any;
    handleBlur: (e: any) => void;
    handleChange: (e: any) => void;
    setCopyContractName: (name: string) => void;
    targetClient: any;
    setTargetClient: (client: any) => void;
    handleGetRulesForCrossClient: (client: any) => void;
    clients: any[];
    isSuperAdmin: boolean;
    selectedClient: number; // or string, checking usage it seems to be ID
    setFieldValue: (field: string, value: any) => void;
    facilitiesFromTargetClient: any[];
    classes: any;
}

const BasicDetailsStep: React.FC<BasicDetailsStepProps> = ({
    contractName,
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    setCopyContractName,
    targetClient,
    setTargetClient,
    handleGetRulesForCrossClient,
    clients,
    isSuperAdmin,
    selectedClient,
    setFieldValue,
    facilitiesFromTargetClient,
    classes
}) => {
    return (
        <Grid container className='pb-2 pl-2'>
            <Grid className='mt-4' item xs={6} md={6}>
                <TextField
                    label="Existing contract name"
                    name="contractName"
                    className={classes.field}
                    value={contractName}
                    inputProps={{ readOnly: true }}
                />
            </Grid>
            <Grid className='mt-4' item xs={6} md={6}>
                <TextField
                    autoFocus
                    required
                    label="New Contract Name"
                    name="newContractName"
                    className={classes.field}
                    value={values.newContractName}
                    onBlur={handleBlur}
                    onChange={e => {
                        handleChange(e);
                        setCopyContractName(e.target.value);
                    }}
                    error={Boolean(touched.newContractName && errors.newContractName)}
                    helperText={touched.newContractName && errors.newContractName}
                />
            </Grid>
            <Grid className='mt-4' item xs={6} md={6}>
                <Autocomplete
                    onChange={(event, newValue) => {
                        if (newValue != null) {
                            setTargetClient(newValue);
                            handleGetRulesForCrossClient(newValue);
                        }
                    }}
                    className={classes.field}
                    value={targetClient}
                    options={orderBy(clients, ['name'])}
                    hidden={!isSuperAdmin}
                    getOptionLabel={(option) => option.name ? option.name : ''}
                    isOptionEqualToValue={(option, value) => value.name === option.name}
                    renderInput={params => (
                        <TextField {...params} label="Target Client *" fullWidth />
                    )}
                    renderOption={(props, option) => (
                        <li {...props} key={option?.clientId}>
                            {option?.name}
                        </li>
                    )}
                />
            </Grid>
            {selectedClient !== targetClient?.clientId && targetClient?.schema && (
                <Grid className='mt-4' item xs={6} md={6}>
                    <FormControl className={classes.formControlAuto}>
                        <Autocomplete
                            onChange={(e, value) => setFieldValue("targetFacilities", value)}
                            filterOptions={filterOptions}
                            value={values.targetFacilities}
                            multiple
                            options={facilitiesFromTargetClient}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                </li>
                            )}
                            renderTags={(tagValue, getTagProps) => {
                                const numTags = tagValue?.length;
                                return (
                                    <Typography variant="caption">
                                        {tagValue?.slice(0, 2).map((option, index) => (
                                            <Chip
                                                size="small"
                                                color="secondary"
                                                key={`key-${index}`}
                                                label={option.name}
                                                {...getTagProps({ index })}
                                            />
                                        ))}
                                        {numTags > 2 && ` + ${numTags - 2}`}
                                    </Typography>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Facilties"
                                    error={Boolean(touched.targetFacilities && errors.targetFacilities)}
                                />
                            )}
                        />
                        <FormHelperText error>{touched.targetFacilities && errors.targetFacilities}</FormHelperText>
                    </FormControl>
                </Grid>
            )}
        </Grid>
    );
};

export default BasicDetailsStep;
